import React from "react";
/** @deprecated  */
export const SvgIcon = ({ color = "currentColor", size = "15", type, className }) => {
  const renderIcon = () => {
    switch (type) {
      case "delete":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke={color}
            className="w-4 h-4 "
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        );
      case "clock":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="6" x2="12" y2="12" />
            <line x1="12" y1="12" x2="16" y2="12" />
          </svg>
        );
      case "star":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={color}
          >
            <polygon points="12 2 15 8 22 9 17 14 18 21 12 17 6 21 7 14 2 9 9 8 12 2" />
          </svg>
        );
      case "both-side-arrow":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 12h16M4 12l4-4M4 12l4 4M20 12l-4-4M20 12l-4 4" />
          </svg>
        );
      case "transfer":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 2v20M2 12h20M12 2l-4 4M12 2l4 4M12 22l-4-4M12 22l4-4" />
          </svg>
        );
      case "success":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16">
            <path
              fill={color}
              d="M11.4 6.85a.5.5 0 0 0-.707-.707l-3.65 3.65l-1.65-1.65a.5.5 0 0 0-.707.707l2 2a.5.5 0 0 0 .707 0l4-4z"
            />
            <path
              fill={color}
              fill-rule="evenodd"
              d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8s8-3.58 8-8s-3.58-8-8-8M1 8c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7s-7-3.13-7-7"
              clip-rule="evenodd"
            />
          </svg>
        );
      case "error":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16">
            <path
              fill={color}
              fill-rule="evenodd"
              d="M8.6 1c1.6.1 3.1.9 4.2 2c1.3 1.4 2 3.1 2 5.1c0 1.6-.6 3.1-1.6 4.4c-1 1.2-2.4 2.1-4 2.4s-3.2.1-4.6-.7s-2.5-2-3.1-3.5S.8 7.5 1.3 6c.5-1.6 1.4-2.9 2.8-3.8C5.4 1.3 7 .9 8.6 1m.5 12.9c1.3-.3 2.5-1 3.4-2.1c.8-1.1 1.3-2.4 1.2-3.8c0-1.6-.6-3.2-1.7-4.3c-1-1-2.2-1.6-3.6-1.7c-1.3-.1-2.7.2-3.8 1S2.7 4.9 2.3 6.3c-.4 1.3-.4 2.7.2 4q.9 1.95 2.7 3c1.2.7 2.6.9 3.9.6M7.9 7.5L10.3 5l.7.7l-2.4 2.5l2.4 2.5l-.7.7l-2.4-2.5l-2.4 2.5l-.7-.7l2.4-2.5l-2.4-2.5l.7-.7z"
              clip-rule="evenodd"
            />
          </svg>
        );
      case "info":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16">
            <path
              fill={color}
              d="M8 15c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6"
            />
            <circle cx="8" cy="6" r=".75" fill={color} />
            <path
              fill={color}
              d="M8 12c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5s.5.22.5.5v3c0 .28-.22.5-.5.5"
            />
          </svg>
        );
      case "warning":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 1024 1024"
          >
            <path
              fill={color}
              d="M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768a384 384 0 0 0 0 768m48-176a48 48 0 1 1-96 0a48 48 0 0 1 96 0m-48-464a32 32 0 0 1 32 32v288a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32"
            />
          </svg>
        );
      case "spinner":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <g stroke={color}>
              <circle cx="12" cy="12" r="9.5" fill="none" stroke-linecap="round" stroke-width="3">
                <animate
                  attributeName="stroke-dasharray"
                  calcMode="spline"
                  dur="1.5s"
                  keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
                  keyTimes="0;0.475;0.95;1"
                  repeatCount="indefinite"
                  values="0 150;42 150;42 150;42 150"
                />
                <animate
                  attributeName="stroke-dashoffset"
                  calcMode="spline"
                  dur="1.5s"
                  keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
                  keyTimes="0;0.475;0.95;1"
                  repeatCount="indefinite"
                  values="0;-16;-59;-59"
                />
              </circle>
              <animateTransform
                attributeName="transform"
                dur="2s"
                repeatCount="indefinite"
                type="rotate"
                values="0 12 12;360 12 12"
              />
            </g>
          </svg>
        );
      case "upload":
        return (
          <svg
            width={size}
            height={size}
            stroke={color}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.3335 2V4.66667C9.3335 5.03486 9.63197 5.33333 10.0002 5.33333H12.6668"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.3335 2V4.66667C9.3335 5.03486 9.63197 5.33333 10.0002 5.33333H12.6668"
              stroke="white"
              stroke-opacity="0.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3335 14H4.66683C3.93045 14 3.3335 13.403 3.3335 12.6667V3.33333C3.3335 2.59695 3.93045 2 4.66683 2H9.3335L12.6668 5.33333V12.6667C12.6668 13.403 12.0699 14 11.3335 14Z"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3335 14H4.66683C3.93045 14 3.3335 13.403 3.3335 12.6667V3.33333C3.3335 2.59695 3.93045 2 4.66683 2H9.3335L12.6668 5.33333V12.6667C12.6668 13.403 12.0699 14 11.3335 14Z"
              stroke="white"
              stroke-opacity="0.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.00016 7.33203V11.332"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.00016 7.33203V11.332"
              stroke="white"
              stroke-opacity="0.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.00016 9.33203L8.00016 7.33203L10.0002 9.33203"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.00016 9.33203L8.00016 7.33203L10.0002 9.33203"
              stroke="white"
              stroke-opacity="0.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "upload-done":
        return (
          <svg
            width={size}
            height={size}
            stroke={color}
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 3.83301V7.83301C14 8.38529 14.4477 8.83301 15 8.83301H19"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14 3.83301V7.83301C14 8.38529 14.4477 8.83301 15 8.83301H19"
              stroke="white"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17 21.833H7C5.89543 21.833 5 20.9376 5 19.833V5.83301C5 4.72844 5.89543 3.83301 7 3.83301H14L19 8.83301V19.833C19 20.9376 18.1046 21.833 17 21.833Z"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17 21.833H7C5.89543 21.833 5 20.9376 5 19.833V5.83301C5 4.72844 5.89543 3.83301 7 3.83301H14L19 8.83301V19.833C19 20.9376 18.1046 21.833 17 21.833Z"
              stroke="white"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9 15.833L11 17.833L15 13.833"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9 15.833L11 17.833L15 13.833"
              stroke="white"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "right-arrow-point":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            stroke={color}
            height={size}
            viewBox="0 0 48 48"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="4"
              d="m19 12l12 12l-12 12"
            />
          </svg>
        );
      case "left-arrow-point":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            stroke={color}
            height={size}
            viewBox="0 0 48 48"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="4"
              d="M31 36L19 24l12-12"
            />
          </svg>
        );
      case "down-arrow-point":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            stroke={color}
            height={size}
            viewBox="0 0 48 48"
          >
            <path
              fill="none"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
              d="M12 19l12 12 12-12"
            />
          </svg>
        );
      case "edit":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.24935 6.41699H5.49935C4.48683 6.41699 3.66602 7.2378 3.66602 8.25033V16.5003C3.66602 17.5128 4.48683 18.3337 5.49935 18.3337H13.7493C14.7619 18.3337 15.5827 17.5128 15.5827 16.5003V13.7503"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.24935 6.41699H5.49935C4.48683 6.41699 3.66602 7.2378 3.66602 8.25033V16.5003C3.66602 17.5128 4.48683 18.3337 5.49935 18.3337H13.7493C14.7619 18.3337 15.5827 17.5128 15.5827 16.5003V13.7503"
              stroke="white"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.25 13.7499H11L18.7917 5.95822C19.5511 5.19882 19.5511 3.96761 18.7917 3.20822C18.0323 2.44882 16.8011 2.44882 16.0417 3.20822L8.25 10.9999V13.7499"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.25 13.7499H11L18.7917 5.95822C19.5511 5.19882 19.5511 3.96761 18.7917 3.20822C18.0323 2.44882 16.8011 2.44882 16.0417 3.20822L8.25 10.9999V13.7499"
              stroke="white"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.666 4.58301L17.416 7.33301"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.666 4.58301L17.416 7.33301"
              stroke="white"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "download":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        );
      case "back-navigate":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        );

      case "minus": {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path fill={color} d="M5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1" />
          </svg>
        );
      }
      case "plus":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill="none"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M18 12h-6m0 0H6m6 0V6m0 6v6"
            />
          </svg>
        );
      case "calendar":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-calendar"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        );
      case "copy":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              d="M21 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19a.3.3 0 0 0-.09 0a.9.9 0 0 0-.33-.11H10a3 3 0 0 0-3 3v1H6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h1a3 3 0 0 0 3-3zm-6-3.53L17.59 8H16a1 1 0 0 1-1-1ZM15 19a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1v7a3 3 0 0 0 3 3h5Zm4-4a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v3a3 3 0 0 0 3 3h3Z"
            />
          </svg>
        );

      case "copied":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 512 512">
            <path
              fill={color}
              fill-rule="evenodd"
              d="M307.503 42.667L426.666 161.83v307.504H85.333V42.667zm-17.69 42.667H128v341.333h256V179.52zm15.104 134.252l30.165 30.166l-100.416 100.416l-57.749-57.75l30.165-30.165l27.584 27.584z"
            />
          </svg>
        );
      case "location":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7"
            />
          </svg>
        );
      case "close":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"
            />
          </svg>
        );
      case "camera-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              fill-rule="evenodd"
              d="M7.574 4.336A3 3 0 0 1 10.07 3h3.86a3 3 0 0 1 2.496 1.336l.812 1.219A1 1 0 0 0 18.07 6H19a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h.93a1 1 0 0 0 .832-.445l.812-1.22zM10 13a2 2 0 1 1 4 0a2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8a4 4 0 0 0 0-8"
              clip-rule="evenodd"
            />
          </svg>
        );
      case "gallery-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path fill={color} d="M18 8a2 2 0 1 1-4 0a2 2 0 0 1 4 0" />
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M11.943 1.25h.114c2.309 0 4.118 0 5.53.19c1.444.194 2.584.6 3.479 1.494c.895.895 1.3 2.035 1.494 3.48c.19 1.411.19 3.22.19 5.529v.088c0 1.909 0 3.471-.104 4.743c-.104 1.28-.317 2.347-.795 3.235q-.314.586-.785 1.057c-.895.895-2.035 1.3-3.48 1.494c-1.411.19-3.22.19-5.529.19h-.114c-2.309 0-4.118 0-5.53-.19c-1.444-.194-2.584-.6-3.479-1.494c-.793-.793-1.203-1.78-1.42-3.006c-.215-1.203-.254-2.7-.262-4.558Q1.25 12.792 1.25 12v-.058c0-2.309 0-4.118.19-5.53c.194-1.444.6-2.584 1.494-3.479c.895-.895 2.035-1.3 3.48-1.494c1.411-.19 3.22-.19 5.529-.19m-5.33 1.676c-1.278.172-2.049.5-2.618 1.069c-.57.57-.897 1.34-1.069 2.619c-.174 1.3-.176 3.008-.176 5.386v.844l1.001-.876a2.3 2.3 0 0 1 3.141.104l4.29 4.29a2 2 0 0 0 2.564.222l.298-.21a3 3 0 0 1 3.732.225l2.83 2.547c.286-.598.455-1.384.545-2.493c.098-1.205.099-2.707.099-4.653c0-2.378-.002-4.086-.176-5.386c-.172-1.279-.5-2.05-1.069-2.62c-.57-.569-1.34-.896-2.619-1.068c-1.3-.174-3.008-.176-5.386-.176s-4.086.002-5.386.176"
              clip-rule="evenodd"
            />
          </svg>
        );
      case "uploading-spinner":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="50"
              cy="50"
              r="40"
              stroke={color}
              stroke-width="8"
              stroke-linecap="round"
              stroke-dasharray="150"
              stroke-dashoffset="75"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 50 50"
                to="360 50 50"
                dur="1.5s"
                repeatCount="indefinite"
              />
            </circle>

            <g stroke={color} stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
              <line x1="50" y1="30" x2="50" y2="60" />

              <polyline points="40,40 50,30 60,40" fill="none" />

              <line x1="35" y1="70" x2="65" y2="70" />
            </g>
          </svg>
        );
      case "downloading-spinner":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="50"
              cy="50"
              r="40"
              stroke={color}
              stroke-width="6"
              stroke-linecap="round"
              stroke-dasharray="150"
              stroke-dashoffset="75"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 50 50"
                to="360 50 50"
                dur="1.5s"
                repeatCount="indefinite"
              />
            </circle>
            <g stroke={color} stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
              <line x1="50" y1="35" x2="50" y2="60" />
              <polyline points="40,55 50,65 60,55" fill="none" />
              <line x1="35" y1="70" x2="65" y2="70" />
            </g>
          </svg>
        );
      case "left-arrow":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="m4 12l-.354-.354l-.353.354l.353.354zm15 .5a.5.5 0 0 0 0-1zM9.646 5.646l-6 6l.708.708l6-6zm-6 6.708l6 6l.708-.708l-6-6zM4 12.5h15v-1H4z"
            />
          </svg>
        );
      case "dustbin":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.66797 6.41683H18.3346"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.16536 10.0835V15.5835"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.8333 10.0835V15.5835"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.58203 6.4165L5.4987 17.4165C5.4987 18.429 6.31951 19.2498 7.33203 19.2498H14.6654C15.6779 19.2498 16.4987 18.429 16.4987 17.4165L17.4154 6.4165"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.25 6.41667V3.66667C8.25 3.16041 8.66041 2.75 9.16667 2.75H12.8333C13.3396 2.75 13.75 3.16041 13.75 3.66667V6.41667"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "zoomin":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 256 256">
            <g fill={color} fill-rule="evenodd">
              <path d="M120.46 158.29c-30.166 8.65-61.631-8.792-70.281-38.957s8.792-61.63 38.957-70.28s61.63 8.792 70.28 38.957c4.417 15.403-1.937 38.002-9.347 50.872c-.614 1.067 59.212 53.064 59.212 53.064l-17.427 17.63l-53.514-56.72s-10.233 3.241-17.88 5.434M104 144c22.091 0 40-17.909 40-40s-17.909-40-40-40s-40 17.909-40 40s17.909 40 40 40" />
              <path d="M111.912 80.047h-15.95v16.037H80v15.992h15.962V128h15.95v-15.924H128V96.084h-16.088z" />
            </g>
          </svg>
        );
      case "zoomout":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 256 256">
            <g fill={color} fill-rule="evenodd">
              <path d="M120.46 158.29c-30.166 8.65-61.631-8.792-70.281-38.957s8.792-61.63 38.957-70.28s61.63 8.792 70.28 38.957c4.417 15.403-1.937 38.002-9.347 50.872c-.614 1.067 59.212 53.064 59.212 53.064l-17.427 17.63l-53.514-56.72s-10.233 3.241-17.88 5.434M104 144c22.091 0 40-17.909 40-40s-17.909-40-40-40s-40 17.909-40 40s17.909 40 40 40" />
              <path d="M80 96.084v15.992h48V96.084z" />
            </g>
          </svg>
        );
      case "close":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"
            />
          </svg>
        );
      case "filter-icon-off":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.50109 1H14.5011C14.7929 1.10236 15.021 1.33401 15.1188 1.62742C15.2166 1.92084 15.1732 2.243 15.0011 2.5L10.0011 8V15L6.00109 12V8L1.00109 2.5C0.829016 2.243 0.785548 1.92084 0.883353 1.62742C0.981158 1.33401 1.20923 1.10236 1.50109 1"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "filter-icon-on":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.50109 0H14.5011C14.7929 0.102358 15.021 0.334005 15.1188 0.627421C15.2166 0.920837 15.1732 1.243 15.0011 1.5L10.0011 7V14L6.00109 11V7L1.00109 1.5C0.829016 1.243 0.785548 0.920837 0.883353 0.627421C0.981158 0.334005 1.20923 0.102358 1.50109 0Z"
              fill="#4318FF"
            />
          </svg>
        );
      case "save-icon":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 18 17"
            fill={"none"}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.1667 16V9.33333H4.83333V16M4.83333 1V5.16667H11.5M14.8333 16H3.16667C2.72464 16 2.30072 15.8244 1.98816 15.5118C1.67559 15.1993 1.5 14.7754 1.5 14.3333V2.66667C1.5 2.22464 1.67559 1.80072 1.98816 1.48816C2.30072 1.17559 2.72464 1 3.16667 1H12.3333L16.5 5.16667V14.3333C16.5 14.7754 16.3244 15.1993 16.0118 15.5118C15.6993 15.8244 15.2754 16 14.8333 16Z"
              stroke={color}
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "search":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill="none"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"
            />
          </svg>
        );
      case "up-arrow":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.62365 7.49521C0.764303 7.63586 0.955068 7.71488 1.15398 7.71488C1.35289 7.71488 1.54366 7.63586 1.68431 7.49521L5.88452 3.29499V6.08099C5.89138 6.27521 5.97335 6.45917 6.11317 6.59414C6.25298 6.72911 6.43973 6.80454 6.63406 6.80454C6.82839 6.80454 7.01513 6.72911 7.15495 6.59414C7.29477 6.45917 7.37674 6.2752 7.38359 6.08099L7.38359 1.4848C7.38347 1.28605 7.30446 1.09547 7.16392 0.954937C7.02338 0.814399 6.83281 0.735391 6.63406 0.735267L2.03786 0.735267C1.93721 0.731714 1.83687 0.748472 1.74283 0.784539C1.64879 0.820607 1.56298 0.875246 1.49051 0.945197C1.41805 1.01515 1.36042 1.09898 1.32106 1.19169C1.28169 1.2844 1.26141 1.38408 1.26141 1.4848C1.26141 1.58552 1.28169 1.68521 1.32106 1.77791C1.36042 1.87062 1.41805 1.95445 1.49051 2.0244C1.56298 2.09435 1.64879 2.14899 1.74283 2.18506C1.83687 2.22113 1.93721 2.23789 2.03786 2.23433L4.82386 2.23433L0.62365 6.43455C0.330909 6.72729 0.330908 7.20247 0.62365 7.49521Z"
              fill={color}
            />
          </svg>
        );
      case "down-arrow":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 9 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.00082 0.499683C3.80191 0.499683 3.61115 0.578701 3.47049 0.719354C3.32984 0.860006 3.25082 1.05077 3.25082 1.24968L3.25082 7.18968L1.28082 5.21968C1.13865 5.0872 0.950602 5.01508 0.756301 5.01851C0.562 5.02194 0.376615 5.10065 0.239202 5.23806C0.101789 5.37547 0.0230756 5.56086 0.0196476 5.75516C0.0162191 5.94946 0.0883431 6.13751 0.220823 6.27968L3.47082 9.52968C3.61145 9.67013 3.80207 9.74902 4.00082 9.74902C4.19957 9.74902 4.3902 9.67013 4.53082 9.52968L7.78082 6.27968C7.85451 6.21102 7.91361 6.12822 7.9546 6.03622C7.9956 5.94422 8.01764 5.84491 8.01941 5.74421C8.02119 5.6435 8.00267 5.54347 7.96495 5.45009C7.92722 5.3567 7.87108 5.27186 7.79986 5.20064C7.72864 5.12943 7.64381 5.07328 7.55042 5.03556C7.45703 4.99784 7.357 4.97932 7.2563 4.98109C7.1556 4.98287 7.05628 5.00491 6.96428 5.0459C6.87229 5.08689 6.78949 5.146 6.72082 5.21968L4.75082 7.18968L4.75082 1.24968C4.75082 0.835684 4.41482 0.499683 4.00082 0.499683Z"
              fill={color}
            />
          </svg>
        );
      case "car":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 62 34"
            fill={"none"}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M59.9685 15.294L56.4584 12.5514L51.9835 3.2975C51.5053 2.30859 50.7614 1.47514 49.8366 0.892122C48.9118 0.309108 47.8433 -8.87544e-06 46.7529 5.39179e-10H24.1273C23.1795 -1.34977e-05 22.2486 0.253415 21.4294 0.734484C20.6102 1.21555 19.932 1.90708 19.4638 2.73866L14.0467 12.3597C8.75574 12.5039 3.71586 15.9817 3.71586 15.9817C1.79382 16.8463 1.64574 19.3624 1.64574 21.486C1.64574 22.0052 1.7253 22.4261 1.21086 22.4261C0.963792 22.4261 0.726846 22.5251 0.552144 22.7014C0.377443 22.8777 0.279297 23.1168 0.279297 23.3661V26.7233C0.279297 26.9726 0.377443 27.2118 0.552144 27.388C0.726846 27.5643 0.963792 27.6634 1.21086 27.6634H57.4961C59.7265 27.6634 61.5344 25.8389 61.5344 23.5883V18.5161C61.5344 17.894 61.3933 17.2802 61.1219 16.7217C60.8504 16.1632 60.4559 15.6748 59.9685 15.294Z"
              fill={color}
            />
            <path
              d="M6.73047 26.6282C6.73047 21.905 10.5247 18.0762 15.2052 18.0762C19.8857 18.0762 23.68 21.905 23.68 26.6282V27.6639H6.73047V26.6282ZM37.7686 27.6639H54.7181V26.6282C54.7181 21.905 50.9238 18.0762 46.2434 18.0762C41.5629 18.0762 37.7686 21.905 37.7686 26.6282V27.6639Z"
              fill={"white"}
            />
            <path
              d="M22.2305 26.8164C22.2305 30.6376 19.1607 33.7353 15.374 33.7353C11.5873 33.7353 8.51758 30.6376 8.51758 26.8164C8.51758 22.9952 11.5873 19.8975 15.374 19.8975C19.1607 19.8975 22.2305 22.9952 22.2305 26.8164ZM46.4121 19.8975C42.6254 19.8975 39.5557 22.9952 39.5557 26.8164C39.5557 30.6376 42.6254 33.7353 46.4121 33.7353C50.1989 33.7353 53.2686 30.6376 53.2686 26.8164C53.2686 22.9952 50.1989 19.8975 46.4121 19.8975Z"
              fill={"black"}
            />
            <path
              d="M19.8689 26.8162C19.8689 29.3208 17.8568 31.3512 15.3749 31.3512C12.8929 31.3512 10.8809 29.3208 10.8809 26.8162C10.8809 24.3116 12.8929 22.2812 15.3749 22.2812C17.8568 22.2812 19.8689 24.3118 19.8689 26.8162ZM46.413 22.2814C43.931 22.2814 41.919 24.3118 41.919 26.8163C41.919 29.3209 43.931 31.3513 46.413 31.3513C48.8949 31.3513 50.907 29.3209 50.907 26.8163C50.907 24.3118 48.8949 22.2814 46.413 22.2814Z"
              fill={"white"}
            />
            <path
              d="M19.9019 11.413L51.1413 11.5015C51.781 11.5033 52.2008 10.8274 51.9202 10.2472L49.4525 5.14459C48.8145 3.82516 47.4622 2.97266 46.0073 2.97266H25.1375C24.5408 2.97266 23.9547 3.13223 23.4389 3.43513C22.9231 3.73803 22.4961 4.17344 22.2012 4.69703L19.1531 10.1105C18.8264 10.6907 19.2405 11.4112 19.9019 11.413Z"
              fill={"white"}
            />
            <path d="M36.9297 0.883789H40.282V13.1857H36.9297V0.883789Z" fill={color} />
            <path
              d="M16.9491 26.8151C16.9491 27.6924 16.2443 28.4036 15.3749 28.4036C14.5055 28.4036 13.8008 27.6924 13.8008 26.8151C13.8008 25.9377 14.5055 25.2266 15.3749 25.2266C16.2443 25.2266 16.9491 25.9377 16.9491 26.8151ZM46.4129 25.2266C45.5435 25.2266 44.8388 25.9377 44.8388 26.8151C44.8388 27.6924 45.5435 28.4036 46.4129 28.4036C47.2823 28.4036 47.9871 27.6924 47.9871 26.8151C47.9872 25.9377 47.2823 25.2266 46.4129 25.2266Z"
              fill={color}
            />
            <path
              d="M61.5269 22.1858H60.6019C59.6023 22.1858 58.9785 21.3681 58.9785 20.3593C58.9785 19.3506 59.6023 18.5329 60.6019 18.5329H61.5269V22.1858ZM1.61663 21.9351H2.66579C3.66539 21.9351 4.28915 21.1174 4.28915 20.1087C4.28915 19.1 3.66539 18.2822 2.66579 18.2822H1.95635C1.57427 19.0303 1.61663 21.9351 1.61663 21.9351Z"
              fill={"white"}
            />
            <path
              d="M24.9512 9.34665V11.7029C24.9512 12.3926 24.0082 12.7985 23.3133 12.4091C22.828 12.1371 22.3357 11.8087 21.9916 11.4514L19.6334 11.449C19.0149 11.448 18.6388 10.7611 18.967 10.2322L21.3278 6.25064L22.3322 9.31843C22.6202 9.07879 22.9563 8.85343 23.2904 8.65399C23.9811 8.2413 24.9512 8.64624 24.9512 9.34665ZM51.7254 11.4951C52.2465 11.4935 52.5861 10.9419 52.3566 10.4698L49.064 3.69593C48.9648 3.49183 48.8109 3.31988 48.6197 3.19963C48.4285 3.07937 48.2077 3.01563 47.9824 3.01562H46.4128V11.5108L51.7254 11.4951Z"
              fill={"rgb(97,97,97)"}
            />
          </svg>
        );

      case "profit":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 90 73"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.5 70.75C2.5 70.75 8.77975 23.2446 24.5 45.25C40.2203 67.2554 46.5 66.2446 52.5 49.25C59.9168 28.2425 87.258 46.3306 90 31.25"
              stroke="url(#paint0_linear_1658_59565)"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 29.5C10.21 29.5 5.5 24.79 5.5 19C5.5 13.21 10.21 8.5 16 8.5C21.79 8.5 26.5 13.21 26.5 19C26.5 24.79 21.79 29.5 16 29.5ZM16 10C11.035 10 7 14.035 7 19C7 23.965 11.035 28 16 28C20.965 28 25 23.965 25 19C25 14.035 20.965 10 16 10Z"
              fill="white"
            />
            <path
              d="M13.75 20.5H12.25C11.83 20.5 11.5 20.17 11.5 19.75C11.5 19.33 11.83 19 12.25 19H13.75C14.995 19 16 17.995 16 16.75C16 15.505 14.995 14.5 13.75 14.5H12.25C11.83 14.5 11.5 14.17 11.5 13.75C11.5 13.33 11.83 13 12.25 13H13.75C14.7446 13 15.6984 13.3951 16.4017 14.0983C17.1049 14.8016 17.5 15.7554 17.5 16.75C17.5 17.7446 17.1049 18.6984 16.4017 19.4017C15.6984 20.1049 14.7446 20.5 13.75 20.5Z"
              fill="white"
            />
            <path
              d="M19.75 17.5H12.25C11.83 17.5 11.5 17.17 11.5 16.75C11.5 16.33 11.83 16 12.25 16H19.75C20.17 16 20.5 16.33 20.5 16.75C20.5 17.17 20.17 17.5 19.75 17.5ZM19.75 14.5H12.25C11.83 14.5 11.5 14.17 11.5 13.75C11.5 13.33 11.83 13 12.25 13H19.75C20.17 13 20.5 13.33 20.5 13.75C20.5 14.17 20.17 14.5 19.75 14.5ZM15.25 25C15.01 25 14.77 24.88 14.62 24.67L11.62 20.17C11.5164 20.0049 11.4815 19.8059 11.5226 19.6154C11.5637 19.4249 11.6777 19.258 11.8402 19.1503C12.0026 19.0427 12.2007 19.0028 12.3922 19.0391C12.5837 19.0755 12.7533 19.1853 12.865 19.345L15.865 23.845C16.09 24.19 16 24.655 15.655 24.88C15.52 24.97 15.385 25 15.235 25H15.25Z"
              fill="white"
            />
            <path
              d="M41.9993 6.66699H39.3327V4.00033C39.3327 3.6467 39.1922 3.30756 38.9422 3.05752C38.6921 2.80747 38.353 2.66699 37.9993 2.66699C37.6457 2.66699 37.3066 2.80747 37.0565 3.05752C36.8065 3.30756 36.666 3.6467 36.666 4.00033L36.7133 6.66699H33.9993C33.6457 6.66699 33.3066 6.80747 33.0565 7.05752C32.8065 7.30757 32.666 7.6467 32.666 8.00033C32.666 8.35395 32.8065 8.69309 33.0565 8.94313C33.3066 9.19318 33.6457 9.33366 33.9993 9.33366L36.7133 9.28633L36.666 12.0003C36.666 12.3539 36.8065 12.6931 37.0565 12.9431C37.3066 13.1932 37.6457 13.3337 37.9993 13.3337C38.353 13.3337 38.6921 13.1932 38.9422 12.9431C39.1922 12.6931 39.3327 12.3539 39.3327 12.0003V9.28633L41.9993 9.33366C42.353 9.33366 42.6921 9.19318 42.9422 8.94313C43.1922 8.69309 43.3327 8.35395 43.3327 8.00033C43.3327 7.6467 43.1922 7.30757 42.9422 7.05752C42.6921 6.80747 42.353 6.66699 41.9993 6.66699Z"
              fill="white"
            />
            <path
              d="M57.0007 8.33301H55.6673V6.99967C55.6673 6.82286 55.5971 6.65329 55.4721 6.52827C55.347 6.40325 55.1775 6.33301 55.0007 6.33301C54.8238 6.33301 54.6543 6.40325 54.5292 6.52827C54.4042 6.65329 54.334 6.82286 54.334 6.99967L54.3577 8.33301H53.0007C52.8238 8.33301 52.6543 8.40325 52.5292 8.52827C52.4042 8.65329 52.334 8.82286 52.334 8.99967C52.334 9.17649 52.4042 9.34605 52.5292 9.47108C52.6543 9.5961 52.8238 9.66634 53.0007 9.66634L54.3577 9.64267L54.334 10.9997C54.334 11.1765 54.4042 11.3461 54.5292 11.4711C54.6543 11.5961 54.8238 11.6663 55.0007 11.6663C55.1775 11.6663 55.347 11.5961 55.4721 11.4711C55.5971 11.3461 55.6673 11.1765 55.6673 10.9997V9.64267L57.0007 9.66634C57.1775 9.66634 57.347 9.5961 57.4721 9.47108C57.5971 9.34605 57.6673 9.17649 57.6673 8.99967C57.6673 8.82286 57.5971 8.65329 57.4721 8.52827C57.347 8.40325 57.1775 8.33301 57.0007 8.33301Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1658_59565"
                x1="-1.00002"
                y1="75.75"
                x2="71.0778"
                y2="12.3356"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
              </linearGradient>
            </defs>
          </svg>
        );

      case "balance-icon":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1610_15764)">
              <g clip-path="url(#clip1_1610_15764)">
                <path
                  d="M35.7111 48.0001H12.2873C10.13 48.0001 8.375 46.2451 8.375 44.0878C8.375 41.9306 10.1302 40.1755 12.2873 40.1755H14.5676C15.1694 37.5604 17.5164 35.6045 20.3115 35.6045H27.6868C28.4172 35.6045 29.0096 36.1967 29.0096 36.9272C29.0096 37.6577 28.4172 38.2499 27.6868 38.2499H20.3115C18.5204 38.2499 17.0633 39.7071 17.0633 41.4982C17.0633 42.2288 16.471 42.8209 15.7406 42.8209H12.2873C11.5887 42.8209 11.0205 43.3891 11.0205 44.0878C11.0205 44.7864 11.5887 45.3546 12.2873 45.3546H35.7112C36.4097 45.3546 36.9779 44.7864 36.9779 44.0878C36.9779 43.3893 36.4097 42.8209 35.7112 42.8209H32.2579C31.5275 42.8209 30.9352 42.2287 30.9352 41.4982C30.9352 40.7677 31.5275 40.1755 32.2579 40.1755H35.7112C37.8685 40.1755 39.6235 41.9306 39.6235 44.0878C39.6234 46.2451 37.8684 48.0001 35.7111 48.0001Z"
                  fill="#4318FF"
                />
                <path
                  d="M23.9985 38.118C23.2681 38.118 22.6758 37.5258 22.6758 36.7953V4.45358C22.6758 3.72298 23.2681 3.13086 23.9985 3.13086C24.7289 3.13086 25.3212 3.72308 25.3212 4.45358V36.7953C25.3212 37.5258 24.7291 38.118 23.9985 38.118Z"
                  fill="#4318FF"
                />
                <path
                  d="M38.3066 9.34759H9.69186C8.96145 9.34759 8.36914 8.75537 8.36914 8.02487C8.36914 7.29437 8.96145 6.70215 9.69186 6.70215H38.3067C39.0371 6.70215 39.6294 7.29437 39.6294 8.02487C39.6294 8.75537 39.0372 9.34759 38.3066 9.34759Z"
                  fill="#4318FF"
                />
                <path
                  d="M3.68359 26.7334V26.9583C3.68359 30.2768 6.37375 32.9668 9.69213 32.9668C13.0106 32.9668 15.7007 30.2767 15.7007 26.9583V26.7334H3.68359Z"
                  fill="#E0D9FF"
                />
                <path
                  d="M9.69277 34.2902C5.65017 34.2902 2.36133 31.0014 2.36133 26.9588V26.7338C2.36133 26.0033 2.95364 25.4111 3.68405 25.4111H15.7014C16.4318 25.4111 17.0241 26.0033 17.0241 26.7338V26.9588C17.0241 31.0014 13.7353 34.2902 9.69277 34.2902ZM5.1367 28.0568C5.63217 30.1126 7.48711 31.6447 9.69277 31.6447C11.8984 31.6447 13.7534 30.1125 14.2488 28.0568H5.1367Z"
                  fill="#4318FF"
                />
                <path
                  d="M3.96527 23.2372C3.79717 23.2372 3.62636 23.2051 3.46145 23.137C2.78617 22.8586 2.46433 22.0853 2.74277 21.4099L8.47061 7.52068C8.6748 7.02549 9.1578 6.70215 9.69348 6.70215C10.2294 6.70215 10.712 7.0253 10.9164 7.52068L16.6439 21.4098C16.9224 22.0852 16.6007 22.8585 15.9252 23.1369C15.2495 23.4154 14.4766 23.0937 14.198 22.4184L9.69339 11.4946L5.1887 22.4184C4.97814 22.9287 4.48502 23.2372 3.96527 23.2372Z"
                  fill="#4318FF"
                />
                <path
                  d="M32.2988 26.7334V26.9583C32.2988 30.2768 34.989 32.9668 38.3074 32.9668C41.6258 32.9668 44.3161 30.2767 44.3161 26.9583V26.7334H32.2988Z"
                  fill="#E0D9FF"
                />
                <path
                  d="M38.308 34.2902C34.2654 34.2902 30.9766 31.0014 30.9766 26.9588V26.7338C30.9766 26.0033 31.5689 25.4111 32.2993 25.4111H44.3166C45.047 25.4111 45.6393 26.0033 45.6393 26.7338V26.9588C45.6394 31.0014 42.3506 34.2902 38.308 34.2902ZM33.752 28.0568C34.2475 30.1126 36.1024 31.6447 38.3081 31.6447C40.5138 31.6447 42.3687 30.1125 42.8642 28.0568H33.752Z"
                  fill="#4318FF"
                />
                <path
                  d="M44.0369 23.2372C43.517 23.2372 43.0242 22.9289 42.8135 22.4184L38.3086 11.4946L33.8039 22.4184C33.5254 23.0938 32.7519 23.4155 32.0767 23.1369C31.4014 22.8585 31.0796 22.0852 31.358 21.4098L37.0856 7.52068C37.2899 7.0254 37.7726 6.70215 38.3084 6.70215C38.8441 6.70215 39.3269 7.0253 39.5313 7.52068L45.2591 21.4098C45.5375 22.0852 45.2158 22.8585 44.5404 23.1369C44.3758 23.2049 44.2049 23.2372 44.0369 23.2372Z"
                  fill="#4318FF"
                />
                <path
                  d="M23.9996 7.58424C25.7286 7.58424 27.1301 6.18267 27.1301 4.45374C27.1301 2.72481 25.7286 1.32324 23.9996 1.32324C22.2707 1.32324 20.8691 2.72481 20.8691 4.45374C20.8691 6.18267 22.2707 7.58424 23.9996 7.58424Z"
                  fill="#E0D9FF"
                />
                <path
                  d="M24.0002 8.90644C21.5447 8.90644 19.5469 6.90872 19.5469 4.45312C19.5469 1.99753 21.5447 0 24.0002 0C26.4557 0 28.4535 1.99772 28.4535 4.45331C28.4535 6.90891 26.4559 8.90644 24.0002 8.90644ZM24.0002 2.64544C23.0033 2.64544 22.1924 3.45637 22.1924 4.45322C22.1924 5.45006 23.0033 6.261 24.0002 6.261C24.997 6.261 25.808 5.45006 25.808 4.45322C25.808 3.45647 24.9971 2.64544 24.0002 2.64544Z"
                  fill="#4318FF"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_1610_15764">
                <rect width="48" height="48" fill="white" />
              </clipPath>
              <clipPath id="clip1_1610_15764">
                <rect width="48" height="48" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      case "right-band-arrow":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 4V7.66661C2 8.66476 2.42461 9.62203 3.18043 10.3278C3.93624 11.0336 4.96134 11.4301 6.03023 11.4301H17.999M13.731 16L17.5567 12.4275C17.6972 12.2964 17.8086 12.1408 17.8847 11.9695C17.9608 11.7982 18 11.6146 18 11.4292M13.732 6.85934L17.5567 10.4328C17.8519 10.7085 18 11.0698 18 11.4311"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );

      case "complete":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12l2 2l4-4m6 2a9 9 0 1 1-18 0a9 9 0 0 1 18 0z"
            />
          </svg>
        );
      case "sort-down":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 320 512">
            <path
              fill="currentColor"
              d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41"
            />
          </svg>
        );
      case "sort-up":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 320 512">
            <path
              fill="currentColor"
              d="M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41"
            />
          </svg>
        );
      case "bell-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              fill-rule="evenodd"
              d="M13 3a1 1 0 1 0-2 0v.75h-.557A4.214 4.214 0 0 0 6.237 7.7l-.221 3.534a7.4 7.4 0 0 1-1.308 3.754a1.617 1.617 0 0 0 1.135 2.529l3.407.408V19a2.75 2.75 0 1 0 5.5 0v-1.075l3.407-.409a1.617 1.617 0 0 0 1.135-2.528a7.4 7.4 0 0 1-1.308-3.754l-.221-3.533a4.214 4.214 0 0 0-4.206-3.951H13zm-2.25 16a1.25 1.25 0 1 0 2.5 0v-.75h-2.5z"
              clip-rule="evenodd"
            />
          </svg>
        );
      case "confirmation-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <g
              fill="none"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            >
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10" />
              <path d="M9 9c0-3.5 5.5-3.5 5.5 0c0 2.5-2.5 2-2.5 5m0 4.01l.01-.011" />
            </g>
          </svg>
        );

      case "three-dots-loader":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <circle cx="18" cy="12" r="0" fill={color}>
              <animate
                attributeName="r"
                begin=".67"
                calcMode="spline"
                dur="1.5s"
                keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
                repeatCount="indefinite"
                values="0;2;0;0"
              />
            </circle>
            <circle cx="12" cy="12" r="0" fill={color}>
              <animate
                attributeName="r"
                begin=".33"
                calcMode="spline"
                dur="1.5s"
                keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
                repeatCount="indefinite"
                values="0;2;0;0"
              />
            </circle>
            <circle cx="6" cy="12" r="0" fill={color}>
              <animate
                attributeName="r"
                begin="0"
                calcMode="spline"
                dur="1.5s"
                keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
                repeatCount="indefinite"
                values="0;2;0;0"
              />
            </circle>
          </svg>
        );
      case "gear-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              fill-rule="evenodd"
              d="m17.653 10.35l2.056.336a.35.35 0 0 1 .291.343v1.913a.35.35 0 0 1-.288.342l-2.058.362a5.8 5.8 0 0 1-.49 1.185l1.217 1.69a.35.35 0 0 1-.036.45l-1.353 1.352a.35.35 0 0 1-.445.04l-1.707-1.198q-.566.315-1.193.5l-.363 2.048a.35.35 0 0 1-.343.287h-1.913a.35.35 0 0 1-.343-.29l-.34-2.039a6 6 0 0 1-1.197-.495l-1.694 1.186a.35.35 0 0 1-.446-.038L5.655 16.97a.35.35 0 0 1-.036-.448l1.197-1.674a6 6 0 0 1-.5-1.204l-2.029-.36A.35.35 0 0 1 4 12.942v-1.913c0-.17.123-.315.29-.343l2.03-.338q.183-.63.5-1.203L5.636 7.453a.35.35 0 0 1 .039-.445l1.352-1.352c.12-.12.31-.136.448-.037l1.68 1.2a6 6 0 0 1 1.196-.491l.333-2.036A.35.35 0 0 1 11.028 4h1.913c.17 0 .314.122.343.288l.359 2.047q.624.182 1.193.497l1.685-1.211a.35.35 0 0 1 .45.036l1.352 1.352c.12.12.136.308.039.446l-1.2 1.71q.31.565.49 1.185M9.565 12a2.435 2.435 0 1 0 4.87 0a2.435 2.435 0 0 0-4.87 0"
              clip-rule="evenodd"
            />
          </svg>
        );
      case "scheme_change":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18072)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1822_18072)" />
              <path
                d="M5.74935 12.8337V7.87116M11.166 5.75033H16.166M18.2493 11.167V16.167M14.916 14.917L14.0827 14.0837M16.166 5.33366C16.166 4.54783 16.166 4.15533 16.4102 3.91116C16.6543 3.66699 17.0468 3.66699 17.8327 3.66699H18.666C19.4518 3.66699 19.8443 3.66699 20.0885 3.91116C20.3327 4.15533 20.3327 4.54783 20.3327 5.33366V6.16699C20.3327 6.95283 20.3327 7.34533 20.0885 7.58949C19.8443 7.83366 19.4518 7.83366 18.666 7.83366H17.8327C17.0468 7.83366 16.6543 7.83366 16.4102 7.58949C16.166 7.34533 16.166 6.95283 16.166 6.16699V5.33366ZM9.91602 11.5837C9.91602 10.7978 9.91602 10.4053 10.1602 10.1612C10.4043 9.91699 10.7968 9.91699 11.5827 9.91699H12.416C13.2018 9.91699 13.5943 9.91699 13.8385 10.1612C14.0827 10.4053 14.0827 10.7978 14.0827 11.5837V12.417C14.0827 13.2028 14.0827 13.5953 13.8385 13.8395C13.5943 14.0837 13.2018 14.0837 12.416 14.0837H11.5827C10.7968 14.0837 10.4043 14.0837 10.1602 13.8395C9.91602 13.5953 9.91602 13.2028 9.91602 12.417V11.5837ZM16.166 17.8337C16.166 17.0478 16.166 16.6553 16.4102 16.4112C16.6543 16.167 17.0468 16.167 17.8327 16.167H18.666C19.4518 16.167 19.8443 16.167 20.0885 16.4112C20.3327 16.6553 20.3327 17.0478 20.3327 17.8337V18.667C20.3327 19.4528 20.3327 19.8453 20.0885 20.0895C19.8443 20.3337 19.4518 20.3337 18.666 20.3337H17.8327C17.0468 20.3337 16.6543 20.3337 16.4102 20.0895C16.166 19.8453 16.166 19.4528 16.166 18.667V17.8337ZM3.66602 17.8337C3.66602 17.0478 3.66602 16.6553 3.91018 16.4112C4.15435 16.167 4.54685 16.167 5.33268 16.167H6.16602C6.95185 16.167 7.34435 16.167 7.58852 16.4112C7.83268 16.6553 7.83268 17.0478 7.83268 17.8337V18.667C7.83268 19.4528 7.83268 19.8453 7.58852 20.0895C7.34435 20.3337 6.95185 20.3337 6.16602 20.3337H5.33268C4.54685 20.3337 4.15435 20.3337 3.91018 20.0895C3.66602 19.8453 3.66602 19.4528 3.66602 18.667V17.8337ZM3.66602 5.33366C3.66602 4.54783 3.66602 4.15533 3.91018 3.91116C4.15435 3.66699 4.54685 3.66699 5.33268 3.66699H6.16602C6.95185 3.66699 7.34435 3.66699 7.58852 3.91116C7.83268 4.15533 7.83268 4.54783 7.83268 5.33366V6.16699C7.83268 6.95283 7.83268 7.34533 7.58852 7.58949C7.34435 7.83366 6.95185 7.83366 6.16602 7.83366H5.33268C4.54685 7.83366 4.15435 7.83366 3.91018 7.58949C3.66602 7.34533 3.66602 6.95283 3.66602 6.16699V5.33366Z"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18072"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18072" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18072"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );

      case "send-agreement":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="cameraGradient-sendAgreement"
                x1="0"
                y1="0"
                x2="25"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
              <filter
                id="innerShadow-sendAgreement"
                x="-1"
                y="-1"
                width="27"
                height="26"
                filterUnits="userSpaceOnUse"
              >
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feComposite in="SourceAlpha" in2="blur" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1
                              0 0 0 0 1
                              0 0 0 0 1
                              0 0 0 0.16 0"
                />
                <feBlend mode="normal" in2="SourceGraphic" result="innerShadow" />
              </filter>
            </defs>

            <g filter="url(#innerShadow-sendAgreement)">
              <rect
                x="0.5"
                width="24"
                height="24"
                rx="4"
                fill="url(#cameraGradient-sendAgreement)"
              />

              <g transform="translate(5.5, 6)">
                <rect x="0" y="3" width="13" height="9" rx="2" stroke="white" strokeWidth="1.5" />
                <rect x="3" y="0" width="3.5" height="2" rx="0.5" fill="white" />
                <circle cx="6.5" cy="7.5" r="2.2" fill="white" />
              </g>
            </g>
          </svg>
        );
      case "upload-image":
        return (
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "4px",
              background: "linear-gradient(135deg, #868CFF 0%, #4318FF 100%)",
              boxShadow: "1px 1px 3px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M17 7H15.586L14.293 5.707C14.1055 5.51947 13.8512 5.41406 13.586 5.41406H10.414C10.1488 5.41406 9.89453 5.51947 9.70703 5.70703L8.41406 7H7C5.89543 7 5 7.89543 5 9V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V9C19 7.89543 18.1046 7 17 7ZM12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16ZM12 11.5C11.1716 11.5 10.5 12.1716 10.5 13C10.5 13.8284 11.1716 14.5 12 14.5C12.8284 14.5 13.5 13.8284 13.5 13C13.5 12.1716 12.8284 11.5 12 11.5Z" />
            </svg>
          </div>
        );

      case "move_to_primary":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i)">
              <rect x="0.5" y="0" width="24" height="24" rx="4" fill="url(#paint0_linear)" />

              {/* Enlarged head */}
              <circle cx="10.7" cy="8.5" r="3.2" fill="white" />

              {/* Enlarged body */}
              <path
                d="M6 17C6 14.5 8 12.5 10.7 12.5H11C13.5 12.5 15.5 14.5 15.5 17V18H6V17Z"
                fill="white"
              />

              {/* Enlarged vertical arrow line */}
              <path d="M17 16.5V10" stroke="white" strokeWidth="2.2" strokeLinecap="round" />

              {/* Enlarged arrow head */}
              <path
                d="M15.2 12L17 10.2L18.8 12"
                stroke="white"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <filter
                id="filter0_i"
                x="-0.5"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
              </filter>
              <linearGradient
                id="paint0_linear"
                x1="0.830274"
                y1="0"
                x2="24.1697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "history-clock":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 5.3335V8.00016L9.33333 9.3335"
              stroke="#616161"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.28706 7.25689C1.24509 7.66897 1.54512 8.03706 1.9572 8.07904C2.36928 8.12101 2.73737 7.82098 2.77934 7.4089L1.28706 7.25689ZM3.07101 9.74223C2.92889 9.35316 2.49828 9.15297 2.10921 9.29509C1.72014 9.43721 1.51994 9.86782 1.66206 10.2569L3.07101 9.74223ZM1.2832 13.3333C1.2832 13.7475 1.61899 14.0833 2.0332 14.0833C2.44742 14.0833 2.7832 13.7475 2.7832 13.3333H1.2832ZM2.0332 9.99995V9.24995C1.61899 9.24995 1.2832 9.58573 1.2832 9.99995H2.0332ZM5.36654 10.7499C5.78075 10.7499 6.11654 10.4142 6.11654 9.99995C6.11654 9.58573 5.78075 9.24995 5.36654 9.24995V10.7499ZM2.0332 7.3329L2.77934 7.4089C3.04997 4.75208 5.27196 2.72177 7.94235 2.69127L7.93379 1.94132L7.92522 1.19136C4.49186 1.23058 1.63502 3.84098 1.28706 7.25689L2.0332 7.3329ZM7.93379 1.94132L7.94235 2.69127C10.6128 2.66077 12.8805 4.6398 13.2118 7.28974L13.956 7.19672L14.7002 7.10369C14.2743 3.69662 11.3586 1.15215 7.92522 1.19136L7.93379 1.94132ZM13.956 7.19672L13.2118 7.28974C13.543 9.93969 11.8322 12.416 9.23642 13.0438L9.41272 13.7728L9.58903 14.5018C12.9264 13.6947 15.1261 10.5108 14.7002 7.10369L13.956 7.19672ZM9.41272 13.7728L9.23642 13.0438C6.64069 13.6716 3.9873 12.2507 3.07101 9.74223L2.36654 9.99956L1.66206 10.2569C2.84015 13.482 6.25165 15.3089 9.58903 14.5018L9.41272 13.7728ZM2.0332 13.3333H2.7832V9.99995H2.0332H1.2832V13.3333H2.0332ZM2.0332 9.99995V10.7499H5.36654V9.99995V9.24995H2.0332V9.99995Z"
              fill={color}
            />
          </svg>
        );

      case "table-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              d="M6 5h11a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3M4 17a2 2 0 0 0 2 2h5v-3H4zm7-5H4v3h7zm6 7a2 2 0 0 0 2-2v-1h-7v3zm2-7h-7v3h7zM4 11h7V8H4zm8 0h7V8h-7z"
            />
          </svg>
        );

      case "drag-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16">
            <path
              fill={color}
              fill-rule="evenodd"
              d="M5.5 4.75a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0m3.5 0a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0M5.5 7.995a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0m3.5 0a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0M5.5 11.25a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0m3.5 0a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0"
              clip-rule="evenodd"
            />
          </svg>
        );
      case "filters-group":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <g fill={color}>
              <path d="M19.396 11.056a6 6 0 0 1-5.647 10.506q.206-.21.396-.44a8 8 0 0 0 1.789-6.155a8.02 8.02 0 0 0 3.462-3.911m-14.787-.005a7.99 7.99 0 0 0 9.386 4.698a6 6 0 1 1-9.534-4.594z" />
              <path d="M12 2a6 6 0 1 1-6 6l.004-.225A6 6 0 0 1 12 2" />
            </g>
          </svg>
        );
      case "round-call-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 512 512">
            <path
              fill="none"
              stroke={color}
              stroke-miterlimit="10"
              stroke-width="32"
              d="M451 374c-15.88-16-54.34-39.35-73-48.76c-24.3-12.24-26.3-13.24-45.4.95c-12.74 9.47-21.21 17.93-36.12 14.75s-47.31-21.11-75.68-49.39s-47.34-61.62-50.53-76.48s5.41-23.23 14.79-36c13.22-18 12.22-21 .92-45.3c-8.81-18.9-32.84-57-48.9-72.8C119.9 44 119.9 47 108.83 51.6A160 160 0 0 0 83 65.37C67 76 58.12 84.83 51.91 98.1s-9 44.38 23.07 102.64s54.57 88.05 101.14 134.49S258.5 406.64 310.85 436c64.76 36.27 89.6 29.2 102.91 23s22.18-15 32.83-31a159 159 0 0 0 13.8-25.8C465 391.17 468 391.17 451 374Z"
            />
          </svg>
        );
      case "call-hang-up-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 14 14">
            <path
              fill={color}
              fill-rule="evenodd"
              d="M.183.183a.625.625 0 0 1 .884 0l6.155 6.155l1.013-1.013l.003-.004a.415.415 0 0 0 0-.565l-.007-.007a1.667 1.667 0 0 1 0-2.322l.004-.004L10.067.592l.004-.005a1.676 1.676 0 0 1 2.33 0l.01.01l.42.43a3.73 3.73 0 0 1 .506 4.635l-.008.012a28.5 28.5 0 0 1-3.03 3.742l3.518 3.517a.625.625 0 1 1-.884.884L8.984 9.868l-.013-.013L6.786 7.67l-.013-.013l-6.59-6.59a.625.625 0 0 1 0-.884m7.923 7.039l1.31 1.31a27 27 0 0 0 2.875-3.554a2.48 2.48 0 0 0-.342-3.066l-.008-.008l-.418-.427a.427.427 0 0 0-.576.002L9.121 3.305a.417.417 0 0 0 0 .566a1.665 1.665 0 0 1-.003 2.339zm-3.34.99a1.667 1.667 0 0 0-2.32 0l-.002.002l-1.841 1.822l-.008.007a1.676 1.676 0 0 0 0 2.33l.01.01l.43.42a3.73 3.73 0 0 0 4.636.506l.01-.007a29 29 0 0 0 2.655-2.027a.625.625 0 0 0-.816-.947a27 27 0 0 1-2.532 1.934a2.48 2.48 0 0 1-3.067-.341l-.008-.008l-.427-.418a.427.427 0 0 1 0-.575l1.836-1.816a.417.417 0 0 1 .57 0v.001a1.666 1.666 0 0 0 2.33 0a.625.625 0 1 0-.874-.894a.416.416 0 0 1-.581 0m0 0l-.438.446z"
              clip-rule="evenodd"
            />
          </svg>
        );
      case "add-payment":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="addCashGradient"
                x1="0"
                y1="0"
                x2="25"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
              <filter
                id="addCashShadow"
                x="-1"
                y="-1"
                width="27"
                height="26"
                filterUnits="userSpaceOnUse"
              >
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feComposite in="SourceAlpha" in2="blur" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1
                  0 0 0 0 1
                  0 0 0 0 1
                  0 0 0 0.16 0"
                />
                <feBlend mode="normal" in2="SourceGraphic" result="innerShadow" />
              </filter>
            </defs>
            <g filter="url(#addCashShadow)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#addCashGradient)" />
              <g transform="translate(3, 4)">
                <rect x="1" y="3" width="16" height="10" rx="1.5" stroke="white" fill="none" />

                <text
                  x="7"
                  y="10"
                  fill="white"
                  font-size="6.5"
                  font-family="Arial, sans-serif"
                  font-weight="bold"
                >
                  ₹
                </text>

                <path d="M14.5 0V1.5H16V2.5H14.5V4H13.5V2.5H12V1.5H13.5V0H14.5Z" fill="white" />
              </g>
            </g>
          </svg>
        );
      case "send-payment-link":
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1996_10230)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1996_10230)" />
              <g clip-path="url(#clip0_1996_10230)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4 5.65714C4 4.71429 4.79543 4 5.71429 4H18.2857C19.2046 4 20 4.71429 20 5.65714V12.0571C20 13 19.2046 13.7143 18.2857 13.7143H5.71429C4.79543 13.7143 4 13 4 12.0571V5.65714ZM14.2857 8.85714C14.2857 9.46335 14.0449 10.0447 13.6162 10.4734C13.1876 10.902 12.6062 11.1429 12 11.1429C11.3938 11.1429 10.8124 10.902 10.3838 10.4734C9.9551 10.0447 9.71429 9.46335 9.71429 8.85714C9.71429 8.25093 9.9551 7.66955 10.3838 7.2409C10.8124 6.81224 11.3938 6.57143 12 6.57143C12.6062 6.57143 13.1876 6.81224 13.6162 7.2409C14.0449 7.66955 14.2857 8.25093 14.2857 8.85714ZM8 9.14286C8 9.0303 7.97783 8.91884 7.93475 8.81484C7.89168 8.71085 7.82854 8.61636 7.74895 8.53677C7.66936 8.45717 7.57487 8.39404 7.47087 8.35096C7.36688 8.30789 7.25542 8.28571 7.14286 8.28571C7.0303 8.28571 6.91884 8.30789 6.81484 8.35096C6.71085 8.39404 6.61636 8.45717 6.53677 8.53677C6.45717 8.61636 6.39404 8.71085 6.35096 8.81484C6.30788 8.91884 6.28571 9.0303 6.28571 9.14286C6.28571 9.37019 6.37602 9.5882 6.53677 9.74895C6.69751 9.90969 6.91553 10 7.14286 10C7.37019 10 7.5882 9.90969 7.74895 9.74895C7.90969 9.5882 8 9.37019 8 9.14286ZM16.8571 8.28571C17.0845 8.28571 17.3025 8.37602 17.4632 8.53677C17.624 8.69751 17.7143 8.91553 17.7143 9.14286C17.7143 9.37019 17.624 9.5882 17.4632 9.74895C17.3025 9.90969 17.0845 10 16.8571 10C16.6298 10 16.4118 9.90969 16.2511 9.74895C16.0903 9.5882 16 9.37019 16 9.14286C16 8.91553 16.0903 8.69751 16.2511 8.53677C16.4118 8.37602 16.6298 8.28571 16.8571 8.28571ZM9.85714 16C9.85714 15.8106 9.78189 15.6289 9.64793 15.4949C9.51398 15.361 9.3323 15.2857 9.14286 15.2857C8.95342 15.2857 8.77174 15.361 8.63778 15.4949C8.50383 15.6289 8.42857 15.8106 8.42857 16V18.2857C8.42857 18.4752 8.50383 18.6568 8.63778 18.7908C8.77174 18.9247 8.95342 19 9.14286 19C9.3323 19 9.51398 18.9247 9.64793 18.7908C9.78189 18.6568 9.85714 18.4752 9.85714 18.2857V16ZM14.8571 15.2857C15.2514 15.2857 15.5714 15.6057 15.5714 16V18.2857C15.5714 18.3795 15.553 18.4724 15.5171 18.5591C15.4812 18.6457 15.4285 18.7245 15.3622 18.7908C15.2959 18.8571 15.2171 18.9097 15.1305 18.9456C15.0438 18.9815 14.9509 19 14.8571 19C14.7633 19 14.6705 18.9815 14.5838 18.9456C14.4971 18.9097 14.4184 18.8571 14.3521 18.7908C14.2857 18.7245 14.2331 18.6457 14.1972 18.5591C14.1613 18.4724 14.1429 18.3795 14.1429 18.2857V16C14.1429 15.6057 14.4629 15.2857 14.8571 15.2857ZM12 16.1429C12.3943 16.1429 12.7143 16.4629 12.7143 16.8571V19.1429C12.7143 19.3323 12.639 19.514 12.5051 19.6479C12.3711 19.7819 12.1894 19.8571 12 19.8571C11.8106 19.8571 11.6289 19.7819 11.4949 19.6479C11.361 19.514 11.2857 19.3323 11.2857 19.1429V16.8571C11.2857 16.4629 11.6057 16.1429 12 16.1429Z"
                  fill="white"
                />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_i_1996_10230"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1996_10230" />
              </filter>
              <linearGradient
                id="paint0_linear_1996_10230"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
              <clipPath id="clip0_1996_10230">
                <rect width="16" height="16" fill="white" transform="translate(4 4)" />
              </clipPath>
            </defs>
          </svg>
        );

      case "user-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12ZM4 20C4.8 16.8 7.6 15 12 15C16.4 15 19.2 16.8 20 20"
              fill="none"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );

      case "double-users":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              d="M16 17v2H2v-2s0-4 7-4s7 4 7 4m-3.5-9.5A3.5 3.5 0 1 0 9 11a3.5 3.5 0 0 0 3.5-3.5m3.44 5.5A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4M15 4a3.4 3.4 0 0 0-1.93.59a5 5 0 0 1 0 5.82A3.4 3.4 0 0 0 15 11a3.5 3.5 0 0 0 0-7"
            />
          </svg>
        );

      case "go-to-page":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              d="M22 3H5a2 2 0 0 0-2 2v4h2V5h17v14H5v-4H3v4a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M7 15v-2H0v-2h7V9l4 3zm13-2h-7v-2h7zm0-4h-7V7h7zm-3 8h-4v-2h4z"
            />
          </svg>
        );
      case "on-call-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <g fill="none">
              <path
                stroke={color}
                stroke-linecap="round"
                stroke-width="1.5"
                d="M13.5 2s2.334.212 5.303 3.182c2.97 2.97 3.182 5.303 3.182 5.303m-7.778-4.949s.99.282 2.475 1.767s1.768 2.475 1.768 2.475"
              />
              <path
                fill={color}
                d="m15.1 15.027l-.543-.516zm.456-.48l.544.517zm2.417-.335l-.374.65zm1.91 1.1l-.374.65zm.539 3.446l.543.517zm-1.42 1.496l-.545-.517zm-1.326.71l.074.745zm-9.86-4.489l.543-.516zm-4.813-9.51l-.749.041zm6.475 1.538l.543.517zm.156-2.81l.613-.433zM8.374 3.91l-.613.433zM5.26 3.609l.544.516zM3.691 5.26l-.543-.516zm7.372 7.795l.544-.517zm4.582 2.488l.455-.48l-1.088-1.033l-.455.48zm1.954-.682l1.91 1.1l.749-1.3l-1.911-1.1zm2.279 3.38l-1.42 1.495l1.087 1.034l1.42-1.496zm-2.275 1.975c-1.435.141-5.18.02-9.244-4.258l-1.087 1.033c4.429 4.663 8.654 4.898 10.478 4.717zm-9.244-4.258c-3.876-4.081-4.526-7.523-4.607-9.033l-1.498.08c.1 1.85.884 5.634 5.018 9.986zm1.376-6.637l.286-.302l-1.087-1.033l-.287.302zm.512-4.062L8.986 3.477l-1.225.866l1.26 1.783zm-5.53-2.168L3.149 4.745l1.088 1.033l1.57-1.653zm4.474 5.713a38 38 0 0 0-.545-.515l-.002.002l-.003.003l-.05.058a1.6 1.6 0 0 0-.23.427c-.098.275-.15.639-.084 1.093c.13.892.715 2.091 2.242 3.7l1.088-1.034c-1.428-1.503-1.78-2.428-1.846-2.884c-.032-.22 0-.335.013-.372l.008-.019l-.028.037l-.018.02s-.002 0-.545-.516m1.328 4.767c1.523 1.604 2.673 2.234 3.55 2.377c.451.073.816.014 1.092-.095a1.5 1.5 0 0 0 .421-.25l.036-.034l.014-.014l.007-.006l.003-.003l.001-.002s.002-.001-.542-.518c-.544-.516-.543-.517-.543-.518l.002-.001l.002-.003l.005-.005l.01-.01l.037-.032q.015-.008-.004.001c-.02.008-.11.04-.3.009c-.402-.066-1.27-.42-2.703-1.929zM8.986 3.477C7.972 2.043 5.944 1.8 4.718 3.092l1.087 1.033c.523-.55 1.444-.507 1.956.218zM3.752 6.926c-.022-.4.152-.8.484-1.148L3.148 4.745c-.536.564-.943 1.347-.894 2.261zm14.705 12.811c-.279.294-.57.452-.854.48l.147 1.492c.747-.073 1.352-.472 1.795-.939zM10.021 9.02c.968-1.019 1.036-2.613.226-3.76l-1.225.866c.422.597.357 1.392-.088 1.86zm9.488 6.942c.821.473.982 1.635.369 2.28l1.087 1.033c1.305-1.374.925-3.673-.707-4.613zm-3.409-.898c.385-.406.986-.497 1.499-.202l.748-1.3c-1.099-.632-2.46-.45-3.335.47z"
              />
            </g>
          </svg>
        );
      case "incoming-call-outline":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              fill-rule="evenodd"
              d="M8.986 3.476c-1.014-1.433-3.042-1.675-4.268-.384l-1.57 1.652c-.536.565-.943 1.348-.894 2.262c.1 1.85.884 5.634 5.018 9.985c4.429 4.664 8.654 4.898 10.478 4.718c.747-.073 1.352-.472 1.795-.939l1.42-1.495c1.305-1.374.925-3.673-.707-4.613l-1.911-1.1c-1.099-.632-2.46-.451-3.335.469l-.408.43a.6.6 0 0 1-.294.007c-.402-.066-1.27-.421-2.703-1.929c-1.428-1.503-1.78-2.429-1.846-2.884c-.032-.22 0-.336.013-.372l.003-.006l.244-.258c.968-1.018 1.036-2.612.226-3.76zm-3.18.649c.522-.55 1.443-.507 1.955.217l1.26 1.784c.423.597.358 1.391-.087 1.86l-.287.302l.532.505a26 26 0 0 0-.533-.503l-.002.001l-.003.003l-.006.007l-.013.015a1 1 0 0 0-.104.14c-.052.081-.109.19-.157.324c-.098.275-.15.638-.084 1.092c.13.893.715 2.092 2.242 3.7c1.523 1.604 2.673 2.234 3.55 2.376c.451.073.816.015 1.092-.094a1.5 1.5 0 0 0 .422-.251l.035-.033l.014-.014l.007-.006l.003-.004l.001-.001s.002-.002-.526-.502l.528.5l.455-.479c.385-.406.986-.497 1.499-.202l1.91 1.1c.821.472.982 1.634.369 2.28l-1.42 1.495c-.28.294-.572.452-.855.48c-1.435.141-5.18.02-9.244-4.259c-3.876-4.08-4.526-7.523-4.607-9.032c-.022-.4.152-.8.484-1.149z"
              clip-rule="evenodd"
            />
            <path
              fill={color}
              d="M18 9.75a.75.75 0 1 0 0-1.5h-1.19l2.72-2.72a.75.75 0 1 0-1.06-1.06l-2.72 2.72V6a.75.75 0 1 0-1.5 0v3c0 .414.336.75.75.75z"
            />
          </svg>
        );
      case "outgoing-call-outline":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <path
              fill={color}
              fill-rule="evenodd"
              d="M8.986 3.476c-1.014-1.433-3.042-1.675-4.268-.384l-1.57 1.652c-.536.565-.943 1.348-.894 2.262c.1 1.85.884 5.634 5.018 9.985c4.429 4.664 8.654 4.898 10.478 4.718c.747-.073 1.352-.472 1.795-.939l1.42-1.495c1.305-1.374.925-3.673-.707-4.613l-1.911-1.1c-1.099-.632-2.46-.451-3.335.469l-.408.43a.6.6 0 0 1-.294.007c-.402-.066-1.27-.421-2.703-1.929c-1.428-1.503-1.78-2.429-1.846-2.884c-.032-.22 0-.336.013-.372l.003-.006l.244-.258c.968-1.018 1.036-2.612.226-3.76zm-3.18.649c.522-.55 1.443-.507 1.955.217l1.26 1.784c.423.597.358 1.391-.087 1.86l-.287.302l.532.505a26 26 0 0 0-.533-.503l-.002.001l-.003.003l-.006.007l-.013.015a1 1 0 0 0-.104.14c-.052.081-.109.19-.157.324c-.098.275-.15.638-.084 1.092c.13.893.715 2.092 2.242 3.7c1.523 1.604 2.673 2.234 3.55 2.376c.451.073.816.015 1.092-.094a1.5 1.5 0 0 0 .422-.251l.035-.033l.014-.014l.007-.006l.003-.004l.001-.001s.002-.002-.526-.502l.528.5l.455-.479c.385-.406.986-.497 1.499-.202l1.91 1.1c.821.472.982 1.634.369 2.28l-1.42 1.495c-.28.294-.572.452-.855.48c-1.435.141-5.18.02-9.244-4.259c-3.876-4.08-4.526-7.523-4.607-9.032c-.022-.4.152-.8.484-1.149z"
              clip-rule="evenodd"
            />
            <path
              fill={color}
              d="M16 4.25a.75.75 0 0 0 0 1.5h1.19l-2.72 2.72a.75.75 0 1 0 1.06 1.06l2.72-2.72V8a.75.75 0 0 0 1.5 0V5a.75.75 0 0 0-.75-.75z"
            />
          </svg>
        );
      case "walkin":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48">
            <g fill={color} fill-rule="evenodd" clip-rule="evenodd">
              <path d="M18.574 31.453a1 1 0 0 1 .948.245l3.249 3.116a1 1 0 0 1 .266 1.005l-.709 2.394a3 3 0 0 1-1.026 1.51l-4.643 3.636a3 3 0 1 1-3.7-4.723l3.889-3.046l1.023-3.455a1 1 0 0 1 .703-.682m.749 2.824l-.649 2.187a1 1 0 0 1-.342.503l-4.14 3.244a1 1 0 0 0 1.233 1.574l4.643-3.637a1 1 0 0 0 .343-.503l.536-1.81zM28 12a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0 2a5 5 0 1 0 0-10a5 5 0 0 0 0 10" />
              <path d="M21.737 14.364c1.428-.53 2.962-.5 4.339.213c1.31.677 2.197 1.823 2.755 3.021q.313.672.583 1.259c.44.954.8 1.737 1.145 2.42c.486.967.842 1.534 1.156 1.9c.27.313.501.472.799.588c.35.138.923.263 1.942.294a2.794 2.794 0 0 1-.167 5.586c-1.357-.041-2.634-.215-3.809-.674c-1.228-.48-2.197-1.213-3.005-2.155a9 9 0 0 1-.28-.342l-.403 2.104l4.367 4.309c.279.274.496.604.639.968l2.484 6.33a2.794 2.794 0 1 1-5.202 2.041l-2.268-5.777l-7.859-7.755a2.8 2.8 0 0 1-.814-2.303l.325-2.87c-.892 1.153-1.642 2.54-2.166 4.18a2.794 2.794 0 1 1-5.324-1.699c1.768-5.538 5.767-9.709 10.73-11.625l.006-.003zm.7 1.874l-.016.006c-4.382 1.693-7.954 5.391-9.541 10.366a.794.794 0 1 0 1.513.483c.994-3.113 2.725-5.468 4.76-7.13a1 1 0 0 1 1.626.886l-.652 5.767a.8.8 0 0 0 .231.654l8.01 7.904q.151.149.229.346l2.345 5.976a.794.794 0 1 0 1.478-.58l-2.484-6.33a.8.8 0 0 0-.181-.276l-4.748-4.684a1 1 0 0 1-.28-.9l.981-5.125a1 1 0 0 1 1.868-.277c.45.857.9 1.59 1.416 2.19c.616.717 1.321 1.244 2.216 1.594c.88.344 1.905.5 3.14.537a.794.794 0 1 0 .048-1.587c-1.14-.034-1.964-.177-2.61-.43c-.63-.246-1.126-.61-1.588-1.149c-.476-.553-.918-1.294-1.425-2.302a83 83 0 0 1-1.17-2.47l-.005-.012q-.269-.587-.58-1.253c-.43-.922-1.05-1.67-1.86-2.089c-.828-.428-1.77-.468-2.722-.115" />
            </g>
          </svg>
        );

      case "uploading-icon-animation":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
            <g
              fill="none"
              stroke={color}
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            >
              <path stroke-dasharray="32" d="M12 3c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9">
                <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="32;0" />
              </path>
              <path
                stroke-dasharray="2 4"
                stroke-dashoffset="6"
                d="M12 21c-4.97 0 -9 -4.03 -9 -9c0 -4.97 4.03 -9 9 -9"
                opacity="0"
              >
                <set fill="freeze" attributeName="opacity" begin="0.45s" to="1" />
                <animateTransform
                  fill="freeze"
                  attributeName="transform"
                  begin="0.45s"
                  dur="0.6s"
                  type="rotate"
                  values="-180 12 12;0 12 12"
                />
                <animate
                  attributeName="stroke-dashoffset"
                  begin="0.85s"
                  dur="0.6s"
                  repeatCount="indefinite"
                  to="0"
                />
              </path>
              <path stroke-dasharray="10" stroke-dashoffset="10" d="M12 16v-7.5">
                <animate
                  fill="freeze"
                  attributeName="stroke-dashoffset"
                  begin="0.85s"
                  dur="0.2s"
                  to="0"
                />
              </path>
              <path stroke-dasharray="8" stroke-dashoffset="8" d="M12 8.5l3.5 3.5M12 8.5l-3.5 3.5">
                <animate
                  fill="freeze"
                  attributeName="stroke-dashoffset"
                  begin="1.05s"
                  dur="0.2s"
                  to="0"
                />
              </path>
            </g>
          </svg>
        );

      case "devices-group":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 36 36">
            <path
              fill={color}
              d="M32 13h-8a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2m0 2v13h-8V15Z"
              class="clr-i-solid clr-i-solid-path-1"
            />
            <path
              fill={color}
              d="M28 4H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8v2H9.32A1.2 1.2 0 0 0 8 27a1.2 1.2 0 0 0 1.32 1h10.6v-.37H20V22H4V6h24v5h2V6a2 2 0 0 0-2-2"
              class="clr-i-solid clr-i-solid-path-2"
            />
            <path fill="none" d="M0 0h36v36H0z" />
          </svg>
        );
      default:
        return null;
    }
  };

  return <div>{renderIcon()}</div>;
};
